(function () {
    'use strict';

    angular.module("imApp").factory("vatSpesificationService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 3431,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
